module.exports = __webpack_public_path__ + "media/images/badge/tattico-cf895817a5c62d5b96e5d6fa3439e504.png";